import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'

import getByPath from 'lodash/get'

import ConversationList from './ConversationList'

import CONVERSATIONS_BY_USER from './../../graphql/Chat/ConversationsByUser.graphql'
import MESSAGE_SUBSCRIPTION from './../../graphql/Chat/MessageSubscription.graphql'
import CREATE_MESSAGE from './../../graphql/Chat/CreateMessage.graphql'
import UPDATE_MESSAGE from './../../graphql/Chat/UpdateMessage.graphql'
import CREATE_CONVERSATION from '../../graphql/Chat/CreateConversation.graphql'

class SingleChat extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedConversation: '',
      unreadMessages: [],
      conversations: [],
      displayChat: false
    }
  }

  componentWillMount() {
    console.log(this.props)
    /*this.props.conversationsByUser.subscribeToMore({
      document: MESSAGE_SUBSCRIPTION,
      updateQuery: (previousState, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return previousState
        } else {
          this.props.conversationsByUser
            .refetch()
            .then(() => {
              const newMessage = getByPath(subscriptionData, 'data.Message.node')

              if (!newMessage) return

              if (newMessage.sender.id !== this.props.user.id
                && !this.props.displayChat) {
                this.audio.play()
              }

              if (this.state.selectedConversation.id == subscriptionData.data.Message.node.conversation.id) {
                const selectedConversation = {
                  ...this.state.selectedConversation
                }
                const newMessages = [...this.state.selectedConversation.messages]

                const message = this.state.selectedConversation.messages
                  .map(msg => msg.id)
                  .find(msg => msg.id === newMessage.id)

                if (newMessage.conversation.id === this.state.selectedConversation.id
                  && !message) {
                  newMessages.push(newMessage)
                  selectedConversation.messages = newMessages

                  this.setState({ selectedConversation })
                }
              }
            })
        }
      }
    })*/
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.conversationsByUser) {
      const filteredConversations = nextProps.conversationsByUser.allConversations.filter(
        item => item.users.filter(item => item.id === nextProps.recipientId).length > 0
      )
      if (filteredConversations.length > 0) {
        this.setState({
          selectedConversation: filteredConversations[0],
          displayChat: true
        })
        this.props.conversationsByUser.refetch()
      } else {
        this.props
          .createConversation({
            variables: {
              usersIds: [nextProps.user.id, nextProps.recipientId]
            }
          })
          .then(result => {
            this.setState({
              selectedConversation: result.data.createConversation,
              displayChat: true
            })
          })
      }
    }
  }

  updateParentState = state => {
    this.setState(state)
  }

  componentDidUpdate() {
    if (this.props.conversationsByUser) {
      this.props.conversationsByUser.refetch()
    }
  }

  render() {
    const { user, handleOpenChat } = this.props
    console.log(this.state)
    //const isDisplayed = displayChat ? 'chat-box' : 'hidden'
    const classes = `chat-box`
    let newMessages = []

    /*if (this.props.data.allConversations) {
      this.props.data.allConversations.forEach(conversation => {
        newMessages = newMessages.concat(conversation.messages).filter(msg => {
          return msg.status === 'Unread' && msg.sender.id !== user.id
        })
      })
    }*/

    let className = newMessages.length ? 'notification-msg' : ''
    let navbarClass = this.props.notificationInNavbar ? '' : 'menu-not-shown'

    return (
      <div className="chat-wrapper">
        <audio
          id="audio"
          ref={audio => {
            this.audio = audio
          }}
          src="http://www.soundjay.com/button/beep-07.wav"
        />
        <span className={className + ' ' + navbarClass} />
        <div className="chat-box  chat-on-message">
          {this.state.selectedConversation && (
            <ConversationList
              user={user}
              updateParentState={this.updateParentState}
              showChatBox={handleOpenChat}
              conversations={this.props.conversationsByUser.allConversations}
              selectedConversation={this.state.selectedConversation}
              single={true}
            />
          )}
        </div>
        <button
          className="chat-bubble"
          id="chat-bubble"
          onClick={() => {
            handleOpenChat()
          }}
        >
          <i className={'icon-close'} id="chat-close" />
          <img className={'hidden'} src="/img/message-icon.svg" id="chat-open" />
        </button>
      </div>
    )
  }
}

export default compose(
  graphql(CREATE_MESSAGE, {
    name: 'createMessage'
  }),
  graphql(UPDATE_MESSAGE, {
    name: 'updateMessage'
  }),
  graphql(CREATE_CONVERSATION, {
    name: 'createConversation'
  }),
  graphql(CONVERSATIONS_BY_USER, {
    name: 'conversationsByUser',
    options: props => ({
      variables: {
        userId: props.user.id
      },
      fetchPolicy: 'network-only'
    })
  })
)(SingleChat)



// WEBPACK FOOTER //
// src/components/Chat/SingleChat.js